import { Repeat } from "lib/@components/repeat"
import { ModifierRow } from "./modifier-row"

export function ModifierRows({ modifiers, baseSubtotal, currencySymbol, showScope, tradeOptions }) {
    // Pre-compute running subtotals so each row can show its cumulative effect.
    const withRunning = []
    let running = baseSubtotal
    for (const m of modifiers) {
        running += m.contribution || 0
        withRunning.push({ ...m, running })
    }
    return (
        <Repeat
            list={withRunning}
            item={<ModifierRow currencySymbol={currencySymbol} showScope={showScope} tradeOptions={tradeOptions} />}
        />
    )
}
